(function($){

    // left: 37, up: 38, right: 39, down: 40,
  // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
  var keys = {37: 1, 38: 1, 39: 1, 40: 1};

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
      get: function () { supportsPassive = true; }
    }));
  } catch(e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

  // call this to Disable Scroll
  function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
  }

  // call this to Enable Scroll
  function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
  }

  var productsLimit = $('div.custom-filters-wrapper').data('productsLimit');
  var location = window.location.href;
  var lastUrlSegmentAndQueryParams = location.substring(location.lastIndexOf('/') + 1).split('?');
  var lastUrlSegment = lastUrlSegmentAndQueryParams[0];
  var queryParams = lastUrlSegmentAndQueryParams[1]; 
  if (lastUrlSegment == "collections") {
  var totalProducts = [];
  function loadJSONCollection(cursor) {
	console.log("triggered");
	$.ajax({
	  url:	"/api/2022-10/graphql.json",
	  type:	'POST',
      data: JSON.stringify({query: 'query AllProducts($collectionProductLimit: Int!, $cursor: String) { collectionByHandle(handle: "all-products") { handle products(first: $collectionProductLimit, after: $cursor) { pageInfo { hasNextPage hasPreviousPage } edges { cursor node { id handle title description onlineStoreUrl tags priceRange { minVariantPrice { amount } maxVariantPrice { amount } } images(first: 5) { edges { node { id originalSrc } } } collections(first: 10) { edges { node { handle } } }} } } } }', variables: {"collectionProductLimit": 250, "cursor": cursor}}),
      headers: {
        "X-Shopify-Storefront-Access-Token": window.storefront_access_token,
        "Content-Type": "application/json"
      }
	})
	.done(function(data) {
      console.log('====', data);
      totalProducts = totalProducts.concat(data.data.collectionByHandle.products.edges);
      console.log(totalProducts);
      var paramsObj = {
        "c": [],
        "t_c": [],
        "t_d": [],
        "t_t": [],
        "p": 1
      };
      if (queryParams) {
        var jsonParamsArray = JSON.parse(JSON.stringify('{"' + queryParams.replace(/&/g, '"},{"').replace(/=/g,'":"') + '"}')).split(',');
        $(jsonParamsArray).each(function(index, stringObj) {
          var obj = JSON.parse(stringObj);
          for (const [key, value] of Object.entries(obj)) {
            console.log(`${key}: ${value}`);
            if (key == "c" || key == "t_c" || key == "t_d" || key == "t_t") {
              paramsObj[key].push(value);
              $(".checkbox-label > input[name='"+value+"']").attr('checked', true);
            }
            if (key == "p") {
              paramsObj[key] = parseInt(value);
            }
          }
        })
        filterProducts(productsLimit, paramsObj.c, paramsObj.t_c, paramsObj.t_d, paramsObj.t_t, paramsObj.p); 
      } else {
        filterProducts(productsLimit, ['all-products'], [], [], [], 1); 
      }
      console.log('paramsObj ==== ', paramsObj);
	})
	.fail(function(data) {})
	.always(function(data) {});
  }
  
  function filterProducts(collectionProductLimit, collections, cepageTags, dosageTags, timeTags, page) {
       var queryParams = '';
      $(collections).each(function(index) {
        queryParams = queryParams ? queryParams + '&c='+this : '?c='+this; 
      })
      $(cepageTags).each(function(index) {
        queryParams = queryParams ? queryParams + '&t_c='+this : '?t_c='+this; 
      })
      $(dosageTags).each(function(index) {
        queryParams = queryParams ? queryParams + '&t_d='+this : '?t_d='+this; 
      })
      $(timeTags).each(function(index) {
        queryParams = queryParams ? queryParams + '&t_t='+this : '?t_t='+this; 
      })
      if (page) {
        queryParams = queryParams ? queryParams + '&p='+page : '?p='+page;
      }
      window.history.replaceState(null, null, queryParams);
       var filteredProductsByCollection = [];
       var filteredProductsByCollectionAndTags = [];
       if (collections && collections.length) {
         $(totalProducts).each(function(index, product){
         	 $(product.node.collections.edges).each(function(i, collection) {
           		if(collections.includes(collection.node.handle)) {
             		filteredProductsByCollection.push(product);
             		return false;
           		}
         	 })
         })
       } else {
           filteredProductsByCollection = filteredProductsByCollection.concat(totalProducts);
       }
       if (cepageTags && cepageTags.length) {
         $(filteredProductsByCollection).each(function(index, product){
            $(cepageTags).each(function(index, tag) {
              if (product.node.tags && product.node.tags.length) {
                var isTagPresent = product.node.tags.some(function (x) {
                  return x.toLowerCase() == tag.toLowerCase();
                })
                if (isTagPresent) {
                  filteredProductsByCollectionAndTags.push(product);
                  return false;
                }
              }
            })
          })
       } else {
         filteredProductsByCollectionAndTags = filteredProductsByCollectionAndTags.concat(filteredProductsByCollection);
       }
       if (dosageTags && dosageTags.length) {
          filteredProductsByCollectionAndTags = $(filteredProductsByCollectionAndTags).filter(function(index, product){
            var isTagPresent = false;
            $(dosageTags).each(function(index, tag) {
              if (product.node.tags && product.node.tags.length) {
                isTagPresent = product.node.tags.some(function (x) {
                  return x.toLowerCase() == tag.toLowerCase();
                })
                if (isTagPresent) {
                  return false;
                }
              }
            })
            return isTagPresent;
          })
       }
       if (timeTags && timeTags.length) {
          filteredProductsByCollectionAndTags = $(filteredProductsByCollectionAndTags).filter(function(index, product){
            var isTagPresent = false;
            $(timeTags).each(function(index, tag) {
              if (product.node.tags && product.node.tags.length) {
                isTagPresent = product.node.tags.some(function (x) {
                  return x.toLowerCase() == tag.toLowerCase();
                })
                if (isTagPresent) {
                  return false;
                }
              }
            })
            return isTagPresent;
          })
       }
       var totalProductsCount = filteredProductsByCollectionAndTags ? filteredProductsByCollectionAndTags.length : 0;
       var paginationEle = createPaginationEle(filteredProductsByCollectionAndTags.length, collectionProductLimit, page, collections, cepageTags, dosageTags, timeTags);
       filteredProductsByCollectionAndTags = filteredProductsByCollectionAndTags.splice((page-1)*collectionProductLimit, collectionProductLimit);
       var allProductElements = "<div class='page-width-collection-list'>"+
                "<div class='collection-template-product-list'>";
	   $(filteredProductsByCollectionAndTags).each(function(index){
          var productEle = createProductEle(this.node, index, filteredProductsByCollectionAndTags.length);
          allProductElements = allProductElements + productEle;
	   });
       
//        all_productElements = all_product_elements + "</div>"+ paginationle + "</div>";
       allProductElements = allProductElements + "</div></div>";
       $('.collections-list-filter-count').text(totalProductsCount + ' products');
       $('.collections-list-filter-count-mobile').text(totalProductsCount);
       $('div.no-products-text').remove();
       $("div.page-width-collection-list").replaceWith($('<div/>').html(allProductElements).contents().append(paginationEle));
       if (totalProductsCount == 0) {
         $('div[id$=__collection-list]').append('<div class="text-center no-products-text">Sorry, no product matches your selection<span></span></div>');
       }
  }
  
  function createProductEle(product, index, totalProductsCount) {
    var productPrice = (parseFloat(product.priceRange.maxVariantPrice.amount) > parseFloat(product.priceRange.minVariantPrice.amount)) ? "À partir de " + parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2).replace(".", ",") + "€" : parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2).replace(".", ",") + "€";
    console.log(productPrice);
    var borderType = 'bottom';
    var borderIndex = index < 3 ? index : index%3;
    if (borderIndex % 2 != 0) {
      borderType = 'corner'; 
    }
    var priceUnitEle = "<div class='collection-template-product-item collection-template-product-item--border-"+ borderType + " has-animated' data-animate>"+
          "<div class='card critical-clear card--reveal' id='Card-"+ product.id + "'" + " data-animate>"+
  "<a href='/products/"+ product.handle + "'" + " class='card__wrapper text-center'>"+

    "<div class='card__image-wrapper' style='padding-top:166.6666667%'>"+
    "<img class='card__image lazyload fade-in'"+
      "data-src='" + product.images.edges[0].node.originalSrc + "'" +
      "data-widths='[900, 1080, 1296, 1512, 1728, 2048]'"+
      "data-aspectratio='0.6'"+
      "loading='lazy'"+
      "data-sizes='auto'>"+
    "<div class='card__preloader'></div>"+
  "</div>"+
    "<div class='card__info'>"+
      "<h3 class='card__name h4'>" + product.title + "</h3>"+
        
    "</div>"+
  "</a>"+
"</div>"+
"</div>";
    return priceUnitEle;
  }
  
  function createPaginationEle(totalProductsCount, limitPageCount, currentPage, collections, cepageTags, dosageTags, timeTags) {
    var totalPages = Math.ceil(totalProductsCount/limitPageCount);
    var paginationEle = '';
    var previousPageEle = '';
    var pagesCountEle = '';
    var nextPageEle = '';
    console.log(totalPages);
    console.log(currentPage);
    if (totalPages && totalPages > 1) {
//       paginationEle = "<div class='card-list__sub-actions'>"+
//                     "<div class='pagination'>";
      paginationEle = "<div class='pagination'>"+
        "</div>";
      if (currentPage == 1) {
        previousPageEle = $("<button class='btn--secondary pagination__btn pagination__btn--previous' disabled=''>"+
        "<svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-arrow-left' viewBox='0 0 4 7'><path fill='#444' d='M0 3.5L4 0v7L0 3.5z'></path></svg>"+
        "<span class='icon__fallback-text'>Précédent</span>"+
        "</button>");
      } else {
        previousPageEle = $("<a href='#' class='btn--secondary pagination__btn pagination__btn--previous'>"+
        "<svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-arrow-left' viewBox='0 0 4 7'><path fill='#444' d='M0 3.5L4 0v7L0 3.5z'></path></svg>"+
        "<span class='icon__fallback-text'>Précédent</span>"+
        "</a>");
        previousPageEle.click(function(ev){
          ev.preventDefault(); // prevent default click handler on "a"
          filterProducts(limitPageCount, collections, cepageTags, dosageTags, timeTags, currentPage - 1);
        });
      }
      if (currentPage == totalPages) {
        nextPageEle = $("<button class='btn--secondary pagination__btn pagination__btn--next' disabled=''>"+
        "<svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-arrow-right' viewBox='0 0 4 7'><path fill='#444' d='M4 3.5L0 7V0z'></path></svg>"+
        "<span class='icon__fallback-text'>Suivant</span>"+
        "</button>");
      } else {
        nextPageEle = $("<a href='#' class='btn--secondary pagination__btn pagination__btn--next'>"+
        "<svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-arrow-right' viewBox='0 0 4 7'><path fill='#444' d='M4 3.5L0 7V0z'></path></svg>"+
        "<span class='icon__fallback-text'>Suivant</span>"+
        "</a>");
        nextPageEle.click(function(ev){
          ev.preventDefault(); // prevent default click handler on "a"
          filterProducts(limitPageCount, collections, cepageTags, dosageTags, timeTags, currentPage + 1);
        });
      }
//       previousPageEle = $('<div/>').html(previousPageEle).contents();
//       nextPageEle = $('<div/>').html(nextPageEle).contents();
      var i;
      console.log(collections);
      for(i = 1; i <= totalPages; i++) {
        if (currentPage == i) {
          pagesCountEle = pagesCountEle ? pagesCountEle.append("<span class='pagination__page pagination__page--current spin'>"+ i + "</span>") : $('<div/>').html("<div class='pagination__pages'></div>").contents().append("<span class='pagination__page pagination__page--current spin'>"+ i + "</span>");
        } else {
          var ele = $("<a href='#' class='pagination__page'>"+ i +"</a>");
          ele.click(function(ev){
            ev.preventDefault(); // prevent default click handler on "a"
            filterProducts(limitPageCount, collections, cepageTags, dosageTags, timeTags, parseInt($(this).text()));
          });
          pagesCountEle = pagesCountEle ? pagesCountEle.append(ele) : $('<div/>').html("<div class='pagination__pages'></div>").contents().append(ele);
        }
      }
//     paginationEle = paginationEle + previousPageEle + "<div class='pagination__pages'>"+ pagesCountEle + "</div>" + nextPageEle + "</div></div>";
      paginationEle = $("<div class='card-list__sub-actions'></div>").append($(paginationEle).append(previousPageEle).append(pagesCountEle).append(nextPageEle));
    }
    return paginationEle;
  }
  
  loadJSONCollection();
    
  $('.checkbox-label > input[type="checkbox"]').change(function() {
    var selectedCollections = [], 
      selectedCepageTags = [],
      selectedDosageTags = [],
      selectedTimeTags = [];
  $('div.collections .checkbox-label > input:checked').each(function() {
    selectedCollections.push($(this).attr('name'));
  });
  $('div.cepages .checkbox-label > input:checked').each(function() {
    selectedCepageTags.push($(this).attr('name'));
  });
  $('div.dosage .checkbox-label > input:checked').each(function() {
    selectedDosageTags.push($(this).attr('name'));
  });
  $('div.temps-de-garde .checkbox-label > input:checked').each(function() {
    selectedTimeTags.push($(this).attr('name'));
  });
  filterProducts(productsLimit, selectedCollections, selectedCepageTags, selectedDosageTags, selectedTimeTags, 1);  
  })
  
  
  /* Controls (Desktop + Mobile) */
  const customFilterwrapper = document.querySelector('.collection-list-filter-wrapper');
  const customFilterPanel = document.querySelector('.custom-filters-wrapper');
  const customFilterPanelUnderlay = document.querySelector('.custom-filters-underlay');
  const openFilterPanelButton = document.querySelector('.collection-list-filter-toggle > svg');
  const closeMobileViewFilterPanelButton = document.querySelector('.custom-filters-close-icon-wrapper');
  const closeDesktopViewFilterPanelButton = document.querySelector('.collection-list-filter-toggle > img');
  const openFilterPanelText = document.querySelector('.collection-list-filter-title_tags');
  const closeFilterPanelAfficherButton = document.querySelector('.filter-close-btn');
  const filtersResetButtonOnMobile = document.querySelector('.custom-filters-heading-labels');
  const filtersResetButtonOnDesktop = document.getElementById('reset-filters-text');
  
  /* Event Listeners for above controls */
  openFilterPanelButton.addEventListener('click', openFiltersPanel);
  openFilterPanelText.addEventListener('click', openFiltersPanel);
  closeMobileViewFilterPanelButton.addEventListener('click', closeFiltersPanel);
  closeDesktopViewFilterPanelButton.addEventListener('click', closeFiltersPanel);
  closeFilterPanelAfficherButton.addEventListener('click', closeFiltersPanel);
  customFilterPanelUnderlay.addEventListener('click', closeFiltersPanel);
  filtersResetButtonOnDesktop.addEventListener('click', uncheckAllFilters);
  filtersResetButtonOnMobile.addEventListener('click', uncheckAllFilters);

  /* Functions for callbacks for above events */ 
  function openFiltersPanel() {
    if (window.innerWidth <= 963) {
      openFilterPanelInMobile();
    } else {
      openFiltersPanelInDesktop();
    }
  }
  function openFilterPanelInMobile() {
    closeAllFilterSections();
    resetFilterSectionToggleIcon();
    document.querySelector('.filter-category-expandable.collections-section').classList.add('collections-section-is-open');
    document.getElementById('collections-expandable-toggle').nextSibling.nextSibling.src = "//champagne-telmont.com/cdn/shop/t/60/assets/filtres.svg?v=183626150160856266111747317727"; 
    customFilterPanel.classList.add('unhidden-custom-filters-in-mobile');
    $("body").addClass("disable-scroll");
  }
  
  function closeFiltersPanel() {
    if (window.innerWidth <= 963) {
      customFilterPanel.classList.remove('unhidden-custom-filters-in-mobile');
    } else {
      closeFiltersPanelInDesktop();
    }

    if (jQuery(".checkbox-label > input:checked").length == 0) { 
      filterProducts(productsLimit, ['all-products'], [], [], [], 1); 
     }
  }

  function openFiltersPanelInDesktop() {
	  const collectionsFeaturedImage = document.querySelector('.collection-featured-image'); 
    const collectionsFeaturedImageCoordinates = collectionsFeaturedImage.getBoundingClientRect();
	  OpenFiltersUserInterfaceTransformations();
    //window.scroll(0, window.scrollY + collectionsFeaturedImageCoordinates.bottom + 1); 
    customFilterwrapper.classList.add('on');
    $(".main-content").addClass("filter-on");
    $("body").addClass("disable-scroll");
  }
  
  function OpenFiltersUserInterfaceTransformations(){
    closeDesktopViewFilterPanelButton.classList.add('product-filter-close-button-active');
    closeDesktopViewFilterPanelButton.classList.remove('visually-hidden-keep-element');
    document.querySelector('.collection-list-filter-toggle > svg').classList.add('filter-activation-items-d-none');
	  document.querySelector('.collection-list-filter-title_tags').classList.add('filter-activation-items-d-none');
    customFilterPanel.classList.add('unhidden-custom-filters-in-desktop');
    customFilterPanelUnderlay.classList.add('active-underlay');
  }

  function closeFiltersPanelInDesktop() {
    customFilterPanel.classList.remove('unhidden-custom-filters-in-desktop');
    customFilterPanelUnderlay.classList.remove('active-underlay');
    closeDesktopViewFilterPanelButton.classList.add('visually-hidden-keep-element');
    document.querySelector('.collection-list-filter-toggle > svg').classList.remove('filter-activation-items-d-none');
  	document.querySelector('.collection-list-filter-title_tags').classList.remove('filter-activation-items-d-none');
    customFilterwrapper.classList.remove('on');
    $(".main-content").removeClass("filter-on");
    $("body").removeClass("disable-scroll");
  }

  document.querySelector('.collection-list-filter-toggle > svg').addEventListener('click', function() {
    if (window.innerWidth <= 768) {
      document.querySelector('.site-header').classList.add('hide-site-header');
      disableScroll();
    }
  })

  document.querySelector('.custom-filters-close-icon-wrapper').addEventListener('click', function() {
    if (window.innerWidth <= 768) {
      document.querySelector('.site-header').classList.remove('hide-site-header');
      enableScroll();
    }
  })  

  document.querySelector('.custom-filters-wrapper .filter-close-btn').addEventListener('click', function() {
    if (window.innerWidth <= 768) {
      document.querySelector('.site-header').classList.remove('hide-site-header');
      enableScroll();
    }
  })  

  // For opening and closing filter sections in mobile view.
  document.querySelectorAll('.filter-section-expandable-toggle-wrapper > img').forEach(item => {
    item.addEventListener('click', () => {
      const sectionWithFilterOptions = item.closest('.filter-category-heading').nextSibling.nextSibling;

      if ((sectionWithFilterOptions.classList.contains('collections-section')) && 
          (sectionWithFilterOptions.classList.contains('collections-section-is-open'))) {
        item.src="//champagne-telmont.com/cdn/shop/t/60/assets/menu.svg?v=139921318565022754791747317727";
        sectionWithFilterOptions.classList.remove('collections-section-is-open');

      } else if ((sectionWithFilterOptions.classList.contains('collections-section')) && 
                 !(sectionWithFilterOptions.classList.contains('collections-section-is-open'))) {

        closeAllFilterSections();
        resetFilterSectionToggleIcon();
        item.src="//champagne-telmont.com/cdn/shop/t/60/assets/filtres.svg?v=183626150160856266111747317727";
        sectionWithFilterOptions.classList.add('collections-section-is-open');        

      } else if ((sectionWithFilterOptions.classList.contains('cepages-section')) && 
                 (sectionWithFilterOptions.classList.contains('cepages-section-is-open'))){
        item.src="//champagne-telmont.com/cdn/shop/t/60/assets/menu.svg?v=139921318565022754791747317727";
        sectionWithFilterOptions.classList.remove('cepages-section-is-open');

      } else if ((sectionWithFilterOptions.classList.contains('cepages-section')) && 
                 !(sectionWithFilterOptions.classList.contains('cepages-section-is-open'))){

        closeAllFilterSections();
        resetFilterSectionToggleIcon();
        item.src="//champagne-telmont.com/cdn/shop/t/60/assets/filtres.svg?v=183626150160856266111747317727";
        sectionWithFilterOptions.classList.add('cepages-section-is-open'); 

      } else if ((sectionWithFilterOptions.classList.contains('dosage-section')) && 
                 (sectionWithFilterOptions.classList.contains('dosage-section-is-open'))) {
        item.src="//champagne-telmont.com/cdn/shop/t/60/assets/menu.svg?v=139921318565022754791747317727";
        sectionWithFilterOptions.classList.remove('dosage-section-is-open');      

      } else if ((sectionWithFilterOptions.classList.contains('dosage-section')) && 
                 !(sectionWithFilterOptions.classList.contains('dosage-section-is-open'))) {

        closeAllFilterSections();
        resetFilterSectionToggleIcon();
        item.src="//champagne-telmont.com/cdn/shop/t/60/assets/filtres.svg?v=183626150160856266111747317727";
        sectionWithFilterOptions.classList.add('dosage-section-is-open');     

      } else if ((sectionWithFilterOptions.classList.contains('temps-de-garde-section')) && 
                 (sectionWithFilterOptions.classList.contains('temps-de-garde-section-is-open'))) {
        item.src="//champagne-telmont.com/cdn/shop/t/60/assets/menu.svg?v=139921318565022754791747317727";
        sectionWithFilterOptions.classList.remove('temps-de-garde-section-is-open');      

      } else {

        closeAllFilterSections();
        resetFilterSectionToggleIcon();
        item.src="//champagne-telmont.com/cdn/shop/t/60/assets/filtres.svg?v=183626150160856266111747317727";
        sectionWithFilterOptions.classList.add('temps-de-garde-section-is-open');          
      }
    })
  })

  function closeAllFilterSections() {
    const collectonsSection = document.querySelector('.filter-category-expandable.collections-section');
    const cepagesSection = document.querySelector('.filter-category-expandable.cepages-section');
    const dosageSection = document.querySelector('.filter-category-expandable.dosage-section');
    const TDGSection = document.querySelector('.filter-category-expandable.temps-de-garde-section');

    collectonsSection.classList.remove('collections-section-is-open');
    cepagesSection.classList.remove('cepages-section-is-open');
    dosageSection.classList.remove('dosage-section-is-open'); 
    TDGSection.classList.remove('temps-de-garde-section-is-open'); 
  }

  function resetFilterSectionToggleIcon() {
    document.querySelectorAll('.filter-section-expandable-toggle-wrapper > img').forEach(item => {
      item.src="//champagne-telmont.com/cdn/shop/t/60/assets/menu.svg?v=139921318565022754791747317727";
    })    
  }

  function uncheckAllFilters() {
    const allCheckboxFilters = document.querySelectorAll('.checkbox-label > input');
    allCheckboxFilters.forEach((filter) => { 
      filter.checked = false; 
    });
    filterProducts(productsLimit, ['all-products'], [], [], [], 1); 
  }
  } 
  
})(jQuery);  